import React, { Component } from "react";
import { Bar, Chart } from "react-chartjs-2";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import numeral from "numeral";
import Watermark from "components/Watermark";
import ActionLink from "components/ActionLink";

var mediaQueryList = window.matchMedia("print");
mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
        for (var id in Chart.instances) {
            Chart.instances[id].resize();
        }
    }
});

class BlocksOverview extends Component {
    state = {
        selectedView: "n",
        viewOptions: [
            { value: "n", text: "Nitrogen" },
            { value: "p", text: "Phosphorus" },
        ],
    };

    render() {
        const { budget } = this.props;
        const blocks = budget.blocks && budget.blocks.filter((b) => b.currentResults && b.currentResults.nitrogenOverview).sort((a, b) => (a.type > b.type ? 0 : 1));

        const budgetResults = budget.currentResults || {};
        const { selectedView, viewOptions } = this.state;

        const setActiveTab = (selection) => {
            this.setState({ selectedView: selection });
        };

        const getBlockDetails = (block) => {
            const name = `${block.name.length > 15 ? block.name.substring(0, 14) + "..." : block.name}`;
            const blockResults = block.currentResults || {};
            if (selectedView === "n") return { name: name, perha: blockResults.nitrogenOverview && blockResults.nitrogenOverview.lostToWater, total: blockResults.nitrogenOverview && blockResults.nitrogenOverview.totalLost };
            else return { name: name, perha: blockResults.phosphorusOverview && blockResults.phosphorusOverview.lostToWater, total: blockResults.phosphorusOverview && blockResults.phosphorusOverview.totalLost };
        };

        const blockMap = blocks.map((b) => getBlockDetails(b));

        const nData = {
            labels: blockMap.map((b) => b.name),
            datasets: [
                {
                    fill: "origin",
                    lineTension: 0,
                    backgroundColor: selectedView === "n" ? "#47A96D" : "#e39153",
                    borderColor: "#47A96D",
                    pointRadius: 0,
                    data: blockMap.map((b) => {
                        return b.perha;
                    }),
                },
            ],
        };

        const nTotalData = {
            labels: blockMap.map((b) => b.name),
            datasets: [
                {
                    fill: "origin",
                    lineTension: 0,
                    backgroundColor: selectedView === "n" ? "#47A96D" : "#e39153",
                    borderColor: "#47A96D",
                    pointRadius: 0,
                    data: blockMap.map((b) => {
                        return b.total;
                    }),
                },
            ],
        };

        if (selectedView === "n") {
            if (budgetResults.nitrogenOverview && budgetResults.nitrogenOverview.otherSources) {
                nTotalData.labels.push("Other sources");
                nTotalData.datasets[0].data.push(budgetResults.nitrogenOverview.otherSources);
            }
        } else {
            if (budgetResults.phosphorusOverview && budgetResults.phosphorusOverview.otherSources) {
                nTotalData.labels.push("Other sources");
                nTotalData.datasets[0].data.push(budgetResults.phosphorusOverview.otherSources);
            }
        }

        const options = {
            scales: {
                x: { display: true, ticks: { autoSkip: false } },
                y: { ticks: { beginAtZero: true }, display: true },
            },
            plugins: {
                legend: {
                    display: false,
                },
            },
        };

        return (
            <Panel title="Overview" className="u-mb-md" green open={true} stickyHeaderName="budget.overview.overview.graphs.collapsed">
                <PanelBody>
                    <ul className="SubMenu u-mb-md">
                        {viewOptions.map((o, i) => (
                            <li key={i} className={`SubMenu-item ${o.value === selectedView ? "is-active" : ""}`}>
                                <ActionLink onClick={() => setActiveTab(o.value)}>
                                    <span>{o.text}</span>
                                </ActionLink>
                            </li>
                        ))}
                    </ul>
                    {nData.labels.length > 1 && (
                        <Panel title={selectedView === "n" ? "N loss from root zone per hectare (kg/ha)" : "P loss per hectare (kg/ha)"}>
                            <Watermark />
                            <PanelBody>
                                <Bar data={nData} height={30} options={options} />
                            </PanelBody>
                        </Panel>
                    )}
                    {nTotalData.labels.length > 1 && (
                        <Panel title={selectedView === "n" ? "Total N loss from root zone (kg)" : "Total P loss (kg)"}>
                            <Watermark />
                            <PanelBody>
                                <Bar data={nTotalData} height={30} options={options} />

                                <div className="Table u-mt-md u-pos-rel u-overflow-hidden">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th data-width="md-15 xl-15" id="header-nutrient">
                                                    Loss from root zone
                                                </th>
                                                <th data-width="md-15 xl-15" id="header-blocks" className="u-textRight">
                                                    Blocks (kg/yr)
                                                </th>
                                                <th data-width="md-15 xl-15" id="header-other" className="u-textRight">
                                                    Other sources (kg/yr)
                                                </th>
                                                <th data-width="md-15 xl-15" id="header-other" className="u-textRight">
                                                    Total farm (kg/yr)
                                                </th>
                                                <th data-width="md-15 xl-15" id="header-wetalnds" className="u-textRight">
                                                    Removed by wetlands (kg/yr)
                                                </th>
                                                <th data-width="md-15 xl-15" id="header-farm" className="u-textRight">
                                                    Farm (kg/yr)
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="N" key="N">
                                                <td id="N-label">Nitrogen</td>
                                                <td id="N-Total" className="u-textRight">
                                                    {numeral(budgetResults.nitrogenOverview.totalLost - budgetResults.nitrogenOverview.otherSources).format("0,0")}
                                                </td>
                                                <td id="N-Other" className="u-textRight">
                                                    {numeral(budgetResults.nitrogenOverview.otherSources).format("0,0")}
                                                </td>
                                                <td id="N-Total" className="u-textRight">
                                                    {numeral(budgetResults.nitrogenOverview.totalLost).format("0,0")}
                                                </td>
                                                <td id="N-Wetlands" className="u-textRight">
                                                    {numeral(budgetResults.nitrogenOverview.wetlands).format("0,0")}
                                                </td>
                                                <td id="N-Farm" className="u-textRight">
                                                    {numeral(budgetResults.nitrogenOverview.farmTotalLoss).format("0,0")}
                                                </td>
                                            </tr>
                                            <tr id="P" key="P">
                                                <td id="P-label">Phosphorus</td>
                                                <td id="P-Total" className="u-textRight">
                                                    {numeral(budgetResults.phosphorusOverview.totalLost - budgetResults.phosphorusOverview.otherSources).format("0,0")}
                                                </td>
                                                <td id="P-Other" className="u-textRight">
                                                    {numeral(budgetResults.phosphorusOverview.otherSources).format("0,0")}
                                                </td>
                                                <td id="P-Total" className="u-textRight"></td>
                                                <td id="P-Wetlands" className="u-textRight"></td>
                                                <td id="P-Farm" className="u-textRight">
                                                    {numeral(budgetResults.phosphorusOverview.farmTotalLoss).format("0,0")}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </PanelBody>
                        </Panel>
                    )}
                </PanelBody>
            </Panel>
        );
    }
}
export default BlocksOverview;
